exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".request[data-v-ffdc45d6]{width:100%}.request .title[data-v-ffdc45d6]{margin-right:20px;width:100%;font-size:26px;line-height:1.2;margin-bottom:20px;font-weight:300;position:relative;z-index:2;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;cursor:text;font-family:Open Sans,sans-serif;color:rgba(0,0,0,.85);text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ffdc45d6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/form/Request.vue
// module id = 721b07f9b5a281e76057
// module chunks = 0